import GlobalsStoreModule from '@app/store/modules/GlobalsStoreModule';
import { getModule as getStoreModule } from 'vuex-module-decorators';
import ISlideMaster from '@app/types/presentations/master/ISlideMaster';
import ICustomSlide, { isCustomSlide } from '@app/types/presentations/presentation/ICustomSlide';
import IPresentationMaster from '@app/types/presentations/master/IPresentationMaster';

const globalsStore: GlobalsStoreModule = getStoreModule(GlobalsStoreModule);

export default class SlideUtil {
	public static isSlideUnpublished(slide: ISlideMaster | ICustomSlide): boolean {
		// Custom slide entries may be unpublished in theory,
		// but custom slides will never be unpublished per ux design.
		if (isCustomSlide(slide)) return false;

		const slideMaster: ISlideMaster = slide as ISlideMaster;

		// if slide wasn't unpublished by schedule, it can't be unpublished at all
		// (the slide wouldn't have been provided by the CF delivery API if it was manually unpublished)
		if (!globalsStore.currentlyUnpublishedIdsAsPerSchedule.includes(slideMaster.id)) return false;

		// determine the date this slide was last updated and date it was unpublished via schedule
		const slideMasterUpdatedDate: Date = new Date(slideMaster.dateUpdated || 0);
		const slideLastScheduledActionDate: Date = new Date(
			globalsStore.lastExecutedScheduledActionById[slideMaster.id].dateTime || 0
		);

		// if a slide was updated after being unpublished by schedule it means it isn't unpublished.
		return slideMasterUpdatedDate.getTime() <= slideLastScheduledActionDate.getTime();
	}

	/**
	 * Retrieve id of the chapter a slide is part of in the presentation master
	 * @param master
	 * @param slideId
	 */
	public static getChapterIdBySlideId(master: IPresentationMaster, slideId: string): string | undefined {
		// check if the slide is part of a section. if so we need to find the section's chapter instead
		const searchId =
			Object.keys(master.sectionsById).find(sectionId => master.sectionsById[sectionId].slides.includes(slideId)) ||
			slideId;

		return Object.keys(master.chaptersById).find(chapterId =>
			master.chaptersById[chapterId].items.some(item => item.id === searchId)
		);
	}
}
